import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ApiService } from '../api.service.js';
import { AuthConfig } from '../provide-api.js';

export function loginGuard(): CanActivateFn {
  return async (route, state) => {
    const router = inject(Router);
    const api = inject(ApiService);
    const authConfig = inject(AuthConfig);
    const apiState = api.create(authConfig.tenant, authConfig.realm);
    const auth = await apiState.remote.session.resolveAuth();
    if (auth.type === 'unauthenticated') {
      console.log('redirect to login');
      return router.createUrlTree(['/auth/login']);
    } else {
      return true;
    }
  };
}
